import { DesignsResponse } from '@/types';
import { getParams } from '@/utils/params';
import { fetchFromApiSigned } from './fetchFromApi';
import { setLookupIdAsId } from './setLookupIdAsId';

export const fetchDesignsForUser = (limit: number, offset: number, signal?: AbortSignal) =>
  // in userarea mode a userId param is only set if in shop context, otherwise the contextId is the userId
  fetchFromApiSigned<DesignsResponse>(
    `users/${getParams().userId || getParams().contextId}/designs`,
    {
      limit,
      offset,
      groupSimilarItems: true,
      maxGroupCount: 1000,
      useElevation: true,
      fullData: true,
    },
    {
      signal,
      credentials: 'include',
    }
  ).then((response) => {
    response.designs.forEach(setLookupIdAsId);
    return response;
  });
